import moment from "./moment";

const STORED_DATE_FORMATS = ["YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"];

export const parseStoredDate = (value: any) => {
  const strict = moment(value, STORED_DATE_FORMATS, true);
  return strict.isValid() ? strict : moment(value, "YYYY-MM-DD");
};

export const isDateInRange = (value: any, minDate: any, maxDate: any) => {
  if (value === "" || value === null || value === undefined) return false;
  return parseStoredDate(value).isBetween(
    parseStoredDate(minDate),
    parseStoredDate(maxDate),
  );
};
